import { Component } from "@angular/core";
import { MatTabsModule } from "@angular/material/tabs";
import { PilotageUsersComponent } from "./pilotage-users/pilotage-users.component";
import { PilotageStatistiquesComponent } from "./pilotage-statistiques/pilotage-statistiques.component";
import { TranslateModule } from '@ngx-translate/core';
import { PilotageConsultationPubliqueComponent } from "./pilotage-consultation-publique/pilotage-consultation-publique.component";
import { PilotageParametresComponent } from "./pilotage-parametres/pilotage-parametres.component";

@Component({
    templateUrl: './pilotage.component.html',
    styleUrls: ['./pilotage.component.scss'],
    imports: [
        MatTabsModule,
        TranslateModule,
        PilotageUsersComponent,
        PilotageStatistiquesComponent,
        PilotageConsultationPubliqueComponent,
        PilotageParametresComponent
    ]
})
export class PilotageComponent {

}
